/**
 * CompartilhamentoAppCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'

/* TODO: review generated class */
@HttpExclude()
export class CompartilhamentoAppCollection extends PageCollection<
  CompartilhamentoApp
> {
  constructor() {
    super(CompartilhamentoApp)
  }

  queryAsPage() {
    return this.listCompartilhamentoApp()
  }

  async listCompartilhamentoApp() {
    return await Request.get(`/admin/compartilhamento-app`, {
      params: this.params,
    })
      .name('listCompartilhamentoApp')
      .as(this)
      .getResponse()
  }

  async listCsvCompartilhamentoApp() {
    return await Request.get(`/admin/compartilhamento-app/csv`, {
      params: this.params,
    })
      .name('listCsvCompartilhamentoApp')
      .as(this)
      .getResponse()
  }
}
